import { Button, FormControlLabel, Grid, Modal, Switch, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { includes } from "lodash";
import React from "react";
import BSInput from "../../../common/js/components/BSInput";

const StyledModalPaper = styled("div")(({ theme }) => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
}));

const StyledInstruction = styled("div")({
    marginBottom: "20px",
});

const StyledStatusSwitch = styled(Switch)({
    marginRight: 0,
});

const NameSearchModal = (props) => {
    const {
        searchType,
        setSearchName,
        toggleNameSearchModal,
        handleSaveSearch,
        handleSaveGroup,
        savedSearchName,
        showModal,
        setSearchSelectedToggle,
        saveSelectedOnly,
        tab,
    } = props;

    let today = new Date();
    let date = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
    const type = searchType === "listings" ? "Listings" : searchType === "comps" ? "Comps" : "Properties";
    const tabType = includes(["all_km_listings", "all_km_comps"], tab) ? "Search" : "List";

    return (
        <Modal aria-labelledby="search-name-modal" aria-describedby="set-search-name" open={showModal}>
            <StyledModalPaper>
                <h4 className="modal-title" style={{ textAlign: "center", paddingbottom: "25px" }}>
                    Save Your {tabType}
                </h4>
                {tabType === "Search" ? (
                    <React.Fragment>
                        <StyledInstruction>
                            <Typography variant="body1">
                                Enter a name for your search below. Please remember to make this name unique, as it will
                                be used to identify the search.
                            </Typography>
                        </StyledInstruction>
                        <BSInput
                            id="savedSearchTitle"
                            onChange={(e) => setSearchName(e.target.value, searchType)}
                            placeholder="Enter search name..."
                            extraInputStyles={{ marginBottom: "-20px", marginTop: "30px" }}
                            defaultValue={`${searchType}-${date}`}
                        />
                        {searchType !== "property" ? (
                            <React.Fragment>
                                <FormControlLabel
                                    control={
                                        <StyledStatusSwitch
                                            checked={saveSelectedOnly}
                                            onChange={(e) => setSearchSelectedToggle(e.target.checked)}
                                            value="selectedItemsOnly"
                                        />
                                    }
                                    label={`Retain selected ${type}? (Only Active)`}
                                />
                                <p
                                    style={{
                                        paddingLeft: "47px",
                                        marginTop: "-2px",
                                        lineHeight: "1.46429em",
                                        fontStyle: "italic",
                                        fontWeight: 400,
                                        color: "rgba(0, 0, 0, 0.87)",
                                        fontSize: "13px",
                                    }}
                                >
                                    {`This will pull your selected ${type} to the top of the search and leave unselected ${type} at the bottom. Only selected ${type} are pulled into reports.`}
                                </p>
                            </React.Fragment>
                        ) : (
                            ""
                        )}
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <StyledInstruction>
                            <Typography variant="body1">
                                Enter a name for your list below. Please remember to make this name unique, as it will
                                be used to identify the list.
                            </Typography>
                        </StyledInstruction>
                        <BSInput
                            id="savedGroupTitle"
                            onChange={(e) => setSearchName(e.target.value, searchType)}
                            placeholder="Enter list name..."
                            extraInputStyles={{ marginBottom: "-20px", marginTop: "30px" }}
                            defaultValue={`${searchType}-${date}`}
                        />
                    </React.Fragment>
                )}
                <Grid container justifyContent="flex-end">
                    <Grid item>
                        <Button variant="outlined" onClick={() => toggleNameSearchModal(false)}>
                            Cancel
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            disabled={savedSearchName ? false : true}
                            variant="contained"
                            color="primary"
                            onClick={() => (tabType === "Search" ? handleSaveSearch() : handleSaveGroup())}
                        >
                            Save
                        </Button>
                    </Grid>
                </Grid>
            </StyledModalPaper>
        </Modal>
    );
};

export default NameSearchModal;
